import { CadenceHero } from "../components/portal/CadenceHero";
import { ImpactStrip } from "../components/portal/ImpactStrip";
import { WhoIServe } from "../components/portal/WhoIServe";
import { DualPaths } from "../components/portal/DualPaths";
import { Testimonials } from "../components/portal/Testimonials";
import { BookingEngine } from "../components/portal/BookingEngine";
import { CadenceFooter } from "../components/portal/CadenceFooter";

export const Portal = () => {
  return (
    <>
      <CadenceHero />
      <ImpactStrip />
      <WhoIServe />
      <DualPaths />
      <Testimonials />
      <BookingEngine />
      <CadenceFooter />
    </>
  );
};
